import { useState, useEffect } from "react";
import PatientInfo from "./PatientInfo";
import { getQmaticInformation } from "../../../services/qmatic/smartRegistration";
import {
  fetchTranslationData } from
"../../../services/translation/translation";
import { ServiceTranslation } from "../../../utils/constants";
import { getLayoutDirection } from "../../../utils/util";

const SmartRegistrationDashboard = () => {
  const [ticketDetails, setTicketDetails] = useState({});
  const [translationMap, setTranslationMap] = useState(null);

  const fetchQmaticInfo = async () => {
    try {
      const details = await getQmaticInformation();
      setTicketDetails(details?.data);
    } catch (err) {
      console.error("Error fetching barcode:", err);
    }
  };

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.smartRegistration).then((result) => {
      setTranslationMap(result);
    });
    fetchQmaticInfo();
  }, []);

  return (
    <>
    <div className={` custombody_color ${getLayoutDirection()}`}>
        <PatientInfo ticketDetails={ticketDetails} fetchQmaticInfo={fetchQmaticInfo} translationMap={translationMap} />
    </div>
    </>);

};

export default SmartRegistrationDashboard;